import { injectable } from "inversify";
import type { IFrontLoggerShipping, LoggerMsg } from "@whatslly/commons/frontLogger/types";
import { loggerListener } from "@whatslly/commons/frontLogger/loggerListener";

@injectable()
export class LogShipper implements IFrontLoggerShipping {
  async shipLog(message: LoggerMsg, level: string, name: string): Promise<void> {
    const data = {
      message,
      level,
      source: name,
      userAgent: navigator.userAgent,
    };

    await loggerListener.addLog({ data });
  }
}
